import {
  QrCodeIcon,
  ChatBubbleLeftRightIcon,
  Cog8ToothIcon,
  GlobeAsiaAustraliaIcon,
} from "@heroicons/react/24/outline";

import { ChipIcon } from "src/static/icons";

export const QUESTS = [
  {
    id: 1,
    title: "Scanned",
    description:
      "Get your badge scanned when you attend activities, workshops, and more!",
    image: QrCodeIcon,
    color: "#9344ED",
    backgroundColor: "#EADFF9",
  },
  {
    id: 2,
    title: "Question",
    description: "Find the answers to questions about the event!",
    image: ChatBubbleLeftRightIcon,
    status: "inProgress",
    color: "#F99828",
    backgroundColor: "#FFFBEB",
  },
  {
    id: 3,
    title: "Organizer",
    description:
      "Complete the challenge and show an organizer at the Help desk!",
    image: Cog8ToothIcon,
    color: "#1AB3B0",
    backgroundColor: "#DFF9F4",
  },
  {
    id: 4,
    title: "Networking",
    description:
      "Make new friends by scanning other hackers' badges to network",
    image: GlobeAsiaAustraliaIcon,
    color: "#DA3EC3",
    backgroundColor: "#FAE4FF",
  },
  {
    id: 5,
    title: "Badge",
    description: "Use your badge to complete unique badge quests!",
    image: ChipIcon,
    color: "#3E55DA",
    backgroundColor: "#E6EAFF",
  },
];
